// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.dropdown-container[data-v-d436187e] {\n  position: relative;\n  width: 100%;\n}\n.search[data-v-d436187e] {\n  margin-top: 8px;\n}\n.list[data-v-d436187e] {\n  max-height: 160px;\n  overflow-y: scroll;\n  margin: 8px 5px;\n  --mdc-list-vertical-padding: 0;\n}\n.action-button[data-v-d436187e] {\n  margin-bottom: 8px;\n}\n", ""]);
// Exports
module.exports = exports;
